export default "/images/c1c06d03af2c235a38585206132c07f1.avif";